export default "__VITE_ASSET__b347b2de__"